<router-outlet></router-outlet>
<generic-modal></generic-modal>
<error-popup></error-popup>
<choose-brand-modal></choose-brand-modal>
<app-loader></app-loader>
